import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { TOOLBAR_FORM } from '@editor/src/img/pageIndex';
import i18n from '@i18next/i18n';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';

export const config = {
    id: `${ActionType.INSERT_FORM}-parent`,
    icon: TOOLBAR_FORM,
    content: i18n.t('表格'),
    children: [{ id: ActionType.INSERT_FORM, title: i18n.t('自定义面板') }],
};

export const INSERT_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        icon: <img src={config.icon} alt={''}/>,
    },
    {
        name: `${config.id}-custom`,
        style: {
            width: '200px',
            overflow: 'hidden',
            padding: 0,
            height: 'auto',
        },
        preventHighlight: true,
    },
];

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: wrapIdForBig(`${ActionType.INSERT_FORM}-parent`),
        tooltip: i18n.t('插入表格'),
        text: config.content,
        icon: <img src={config.icon} alt={''}/>,
        style: {
        },
    },
    {
        name: `${config.id}-custom`,
        tooltip: i18n.t('插入表格'),
        text: config.content,
        icon: <img src={config.icon} alt={''}/>,
        style: {
            width: 'auto',
        },
    },
];
